import { Navigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../hooks';
import { useCompany } from '../../hooks/useCompany';
import { RoutePath } from '../../routes';
import { DashboardLoading } from '../_ui';
import { Register } from '../register/Register.component';

export const Onboarding = () => {
  const auth = useAuth();
  const [searchParams] = useSearchParams();
  const { companies } = useCompany();

  if (auth.user) {
    if (!companies) {
      return (
        <div className='h-screen bg-[#E5E5E5]'>
          <DashboardLoading />
        </div>
      );
    }

    // If the user already has access to a company, redirect to the dashboard
    if (companies.length > 0) {
      return <Navigate to='/' />;
    }
    const hsContactId = searchParams.get('hsContactId');
    const searchParam = hsContactId ? `?hsContactId=${hsContactId}` : '';
    return <Navigate to={`/${RoutePath.CREATE_COMPANY_SELF_SERVE}${searchParam}`} replace />;
  }

  if (!searchParams.get('hsContactId')) {
    return <Navigate to='/' />;
  }

  return <Register />;
};
